var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4710",
    "data-name": "Group 4710",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.376,
    height: 13,
    viewBox: "0 0 12.376 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2720",
    "data-name": "Rectangle 2720",
    width: 12.376,
    height: 13,
    fill: "#8b9095"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4573",
    "data-name": "Group 4573",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    d: "M33.095,1.462a1.521,1.521,0,0,1-.2.76c-.528,1.011-1.053,2.023-1.583,3.032a.238.238,0,0,0,0,.26,2.226,2.226,0,0,1,.2,1.844,21.5,21.5,0,0,1-2.09,4.7c-.093.148-.186.3-.283.442a1.028,1.028,0,0,1-1.276.429,14.7,14.7,0,0,1-3.5-1.821,15.841,15.841,0,0,1-2.435-1.995.779.779,0,0,1-.25-.833.832.832,0,0,1,.707-.564,5.494,5.494,0,0,0,2.638-1.229,16.523,16.523,0,0,0,1.47-1.476A2.889,2.889,0,0,1,28.31,3.992a.267.267,0,0,1,.079-.009c.249.047.354-.094.456-.3.482-.957.977-1.907,1.474-2.856a1.457,1.457,0,0,1,2.23-.5,1.415,1.415,0,0,1,.546,1.136M27.159,11.712c.321.125.642.245.958.376a.232.232,0,0,0,.328-.115A15.991,15.991,0,0,0,29.687,9.7c.165-.376.316-.759.475-1.141l-.144-.079L26.553,6.66c-.26-.137-.262-.137-.469.066a6.954,6.954,0,0,1-3.247,1.793l-.19.049-.024.049c.468.39.934.781,1.406,1.166a.169.169,0,0,0,.153,0c.157-.1.307-.208.459-.313a.446.446,0,0,1,.615.071.424.424,0,0,1-.075.608c-.095.082-.2.158-.325.261.482.291.942.571,1.406.844a.147.147,0,0,0,.13-.036,4.647,4.647,0,0,0,.384-.424c.144-.189.268-.395.4-.59a.438.438,0,0,1,.6-.134.423.423,0,0,1,.138.585,2.086,2.086,0,0,1-.151.243c-.2.268-.4.533-.61.819m3.306-3.986c.071-.2.139-.376.2-.557a1.516,1.516,0,0,0-.711-1.827,7.376,7.376,0,0,0-.695-.35,1.842,1.842,0,0,0-2.315.884l3.523,1.849M30.614,4.7c.518-1,1.038-1.987,1.545-2.984a.653.653,0,0,0,.047-.368.555.555,0,0,0-.48-.465.579.579,0,0,0-.625.338q-.577,1.107-1.148,2.216l-.374.721,1.036.541",
    transform: "translate(-20.719 0)",
    fill: "#8b9095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M0,133.282a.631.631,0,0,1,.629-.627.634.634,0,1,1,0,1.269A.635.635,0,0,1,0,133.282",
    transform: "translate(0 -127.018)",
    fill: "#8b9095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M41.178,86.857a.636.636,0,0,1,.637.638.634.634,0,0,1-1.268,0,.631.631,0,0,1,.631-.641",
    transform: "translate(-38.824 -83.166)",
    fill: "#8b9095"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearSearch);
export default __webpack_public_path__ + "static/media/clear-search.f45eeaa2.svg";
export { ForwardRef as ReactComponent };